<template>
  <div>
    <div class="p-lg-3">
      <div class="row justify-content-between">
        <h3 class="mt-0 mb-2 font-weight-bold text-left">Mapa Prescrição</h3>
      </div>
    </div>
    <div class="container-fluid mt-0 mb-5">
      <div class="row justify-content-end">
        <div class="col-1 text-right">
          <v-btn
            class="mt-4"
            fab
            color="primary"
            elevation="1"
            x-small
            title="Saída Internação"
            @click="getPrescricao()"
          >
            <v-icon>mdi mdi-refresh</v-icon>
          </v-btn>
        </div>
        <div class="col-2">
          <v-text-field
            v-model="data_prescricao"
            label="Data"
            type="date"
            hide-details
          />
        </div>
      </div>
    </div>
    <div v-if="!loading">
      <div class="mapa" v-if="agendas.length > 0">
        <div class="prescricao">
          <div class="agenda-item">
            <div class="info-animal style-header"></div>
            <div class="info-horarios">
              <div
                class="horario style-header-time"
                v-for="(horario, index) in horarios"
                :key="index + horario"
              >
                <h6>{{ horario.split(":")[0] }}</h6>
              </div>
            </div>
          </div>
          <div
            class="agenda-item"
            v-for="(item, index) in agendas"
            :key="index"
          >
            <div class="info-animal">
              <v-skeleton-loader
                v-if="!item.internacao.url"
                v-bind="attrs"
                type="image"
                height="100px"
                width="100px"
                class="my-1"
                style="
                  border-radius: 5px;
                  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
                "
              ></v-skeleton-loader>
              <v-template v-else>
                <v-img
                  v-if="item.internacao.url == 'sem-imagem'"
                  src="@/assets/images/default_image.jpg"
                  height="100px"
                  width="100px"
                  class="my-1"
                  style="
                    border-radius: 5px;
                    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
                  "
                >
                </v-img>
                <v-img
                  v-else
                  :src="item.internacao.url"
                  height="100px"
                  width="100px"
                  class="my-1"
                  style="
                    border-radius: 5px;
                    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
                  "
                >
                </v-img>
              </v-template>
              <div class="details-style">
                <div class="nome-animal">
                  <v-btn
                    icon
                    x-small
                    color="primary"
                    title="Mapa Animal"
                    @click="mapaAnimal(item.internacao)"
                    class="mr-1"
                  >
                    <v-icon>mdi mdi-information</v-icon>
                  </v-btn>
                  <span>
                    {{ item.internacao.animal_nome }}
                  </span>
                </div>
                <div class="desc-animal">
                  classe: {{ item.internacao.classe }}, especie:
                  {{ item.internacao.nome_popular }}
                </div>
              </div>
            </div>
            <div class="info-horarios">
              <div
                class="horario"
                v-for="horario in item.comp"
                :key="item.internacao.id + horario.hora"
              >
                <div v-if="horario.compromisso.length > 0">
                  <div>
                    <v-btn
                      icon
                      x-small
                      class="horaItem"
                      :class="getColorMedicamento(horario.compromisso)"
                      title="Medicamento"
                      dark
                      @click="medicamento(item, horario.compromisso)"
                    >
                      {{ horario.compromisso.length }}
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <v-dialog
          v-model="dialogMedicamento"
          width="1000"
          transition="dialog-bottom-transition"
        >
          <modal-medicamento
            v-if="dialogMedicamento"
            :infoMedicamento="infoMedicamento"
            @close="
              getPrescricao();
              dialogMedicamento = false;
            "
          ></modal-medicamento>
        </v-dialog>

        <v-dialog
          v-model="dialogMapaAnimal"
          fullscreen
          transition="dialog-bottom-transition"
        >
          <modal-mapa-animal
            v-if="dialogMapaAnimal"
            :info="infoMapaAnimal"
            :dataMapa="data_prescricao"
            @close="
              getPrescricao();
              dialogMapaAnimal = false;
            "
          ></modal-mapa-animal>
        </v-dialog>
      </div>
      <div v-else>
        <h4 class="text-center">Nenhum prescrição para essa internação</h4>
      </div>
    </div>
    <div class="text-center m-5 col-12" v-else>
      <v-progress-circular indeterminate color="#1daf80"></v-progress-circular>
    </div>
  </div>
</template>

<script>
import Mixin from "@/mixins/vuex_mixin.js";
import ModalMedicamento from "@/components/mapa_prescricao/modal_medicacao.vue";
import ModalMapaAnimal from "@/components/mapa_prescricao/modal_prescricao_animal.vue";
import PrescricaoService from "@/services/prescricao_service.js";
import EntradaService from "@/services/entrada_service.js";

export default {
  mixins: [Mixin],
  components: {
    ModalMedicamento,
    ModalMapaAnimal,
  },
  data: () => ({
    services: {
      // authService: AuthService.build(),
      prescricaoService: PrescricaoService.build(),
      entradaService: EntradaService.build(),
    },
    horarios: [
      "00:00",
      "01:00",
      "02:00",
      "03:00",
      "04:00",
      "05:00",
      "06:00",
      "07:00",
      "08:00",
      "09:00",
      "10:00",
      "11:00",
      "12:00",
      "13:00",
      "14:00",
      "15:00",
      "16:00",
      "17:00",
      "18:00",
      "19:00",
      "20:00",
      "21:00",
      "22:00",
      "23:00",
    ],
    animais: [
      {
        animal: {
          id: 1,
          nome: "Carajá",
          classe: "Mammalia",
          especie: "BUGIO-PRETO",
        },
        horario: [
          {
            idMedicamento: 1,
            remedio: "Morfina",
            dose: "10ml",
            administracao: "Via Oral",
            hora: "08:30",
            status: "aplicado",
          },
          {
            idMedicamento: 2,
            remedio: "Morfina",
            dose: "10ml",
            administracao: "Via Oral",
            hora: "10:10",
            status: "pendente",
          },
          {
            idMedicamento: 3,
            remedio: "Rabica",
            dose: "25ml",
            administracao: "Via Oral",
            hora: "08:00",
            status: "pendente",
          },
          {
            idMedicamento: 4,
            remedio: "Rabica",
            dose: "25ml",
            administracao: "Via Oral",
            hora: "09:15",
            status: "aplicado",
          },
          {
            idMedicamento: 5,
            remedio: "Rabica",
            dose: "10ml",
            administracao: "Via Oral",
            hora: "17:30",
            status: "pendente",
          },
          {
            idMedicamento: 6,
            remedio: "Morfina",
            dose: "10ml",
            administracao: "Via Oral",
            hora: "20:00",
            status: "aplicado",
          },
          {
            idMedicamento: 7,
            remedio: "Rabica",
            dose: "25ml",
            administracao: "Via Oral",
            hora: "13:00",
            status: "aplicado",
          },
          {
            idMedicamento: 8,
            remedio: "Morfina",
            dose: "10ml",
            administracao: "Via Oral",
            hora: "13:00",
            status: "aplicado",
          },
        ],
        agenda: [],
      },
      {
        animal: {
          id: 1,
          nome: "Cariamidae",
          classe: "Ave",
          especie: "SERIEMA",
        },
        horario: [
          {
            idMedicamento: 9,
            remedio: "Morfina",
            dose: "10ml",
            administracao: "Via Oral",
            hora: "15:00",
            status: "pendente",
          },
          {
            idMedicamento: 10,
            remedio: "Morfina",
            dose: "10ml",
            administracao: "Via Oral",
            hora: "06:10",
            status: "aplicado",
          },
        ],
        agenda: [],
      },
    ],
    agendas: [],
    dataHj: new Date(),
    infoMedicamento: {},
    dialogMedicamento: false,
    data_prescricao: "",
    infoMapaAnimal: {},
    dialogMapaAnimal: false,
    unidadeId: JSON.parse(sessionStorage.vuex).unidade.id,
    loading: false,
  }),

  computed: {},

  watch: {
    data_prescricao() {
      if (this.data_prescricao) {
        this.getPrescricao();
      }
    },
  },

  mounted() {
    this.data_prescricao = new Date().toISOString().substr(0, 10);
    this.getPrescricao();
  },

  methods: {
    async getPrescricao() {
      if (!this.loading) {
        this.agendas = [];
        this.loading = true;
        await this.services.prescricaoService
          .getPrescricaoUnidade(
            this.unidadeId,
            this.data_prescricao.replaceAll("-", "")
          )
          // .getPrescricaoUnidade(1, "20240828")
          .then(async (response) => {
            if (response.status == 200) {
              const resp = await response.json();
              for (let index = 0; index < resp.data.length; index++) {
                const element = resp.data[index];
                let animal = { ...element, comp: [] };
                animal.internacao.url = "";
                for (let indexH = 0; indexH < this.horarios.length; indexH++) {
                  animal.comp.push(
                    this.getVacinasHora(animal.agenda, this.horarios[indexH])
                  );
                }
                this.agendas.push(animal);
                this.getThumbEntrada(animal);
              }
            }
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    async getThumbEntrada(animal) {
      await this.services.entradaService
        .getFirstImagemEntrada(animal.internacao.id_entrada)
        .then(async (response) => {
          const index = this.agendas.findIndex(
            (ele) => ele.internacao.id_entrada == animal.internacao.id_entrada
          );
          if (response.status == 200) {
            const resp = await response.json();
            // console.log("r", resp);
            const ext = resp.data.arquivo_nome.split(".");
            this.agendas[
              index
            ].internacao.url = `data:image/${ext[1]};base64,${resp.data.base64}`;
          } else {
            this.agendas[index].internacao.url = "sem-imagem";
            // this.pets[index].url = "../assets/images/default_image.jpeg";
          }
        })
        .catch((e) => {
          console.log("erro ", { e });
        })
        .finally(() => {});
    },
    getVacinasHora(compromissos, hora) {
      let agenda = { hora: hora, compromisso: [] };
      for (let i = 0; i < compromissos.length; i++) {
        const item = compromissos[i];
        if (item.hora_agenda.split(":")[0] == hora.split(":")[0]) {
          agenda.compromisso.push({
            ...item,
            hora_executada: item.status_agenda == 2 ? item.hora_execucao : "",
            data_executada: item.status_agenda == 2 ? item.data_execucao : "",
            obs_executada: item.observacao ?? "",
            status: item.status_agenda == 2 ? "aplicado" : "pendente",
            // hora_executada: item.id_requisiacao ? item.hora_execucao : "",
            // data_executada: item.id_requisiacao ? item.data_execucao : "",
            // obs_executada: item.observacao ?? "",
            // status: item.id_requisiacao ? "aplicado" : "pendente",
          });
        }
      }
      return agenda;
    },
    getColorMedicamento(compromissos) {
      let color = "aplicado";
      let marcaoData = new Date(
        `${compromissos[0].data_agenda}T${compromissos[0].hora_agenda}`
      );
      let novaData = new Date();
      let compromissoPassado = marcaoData < novaData;
      // let compromissoPassado =
      //   this.dataHj.getHours() > compromissos[0].hora_agenda.split(":")[0];
      if (compromissos.length > 1) {
        if (
          compromissos.some((ele) => {
            return ele.status == "pendente";
          })
        ) {
          if (compromissoPassado) {
            color = "atrasado";
          } else {
            color = "pendente";
          }
        }
      } else {
        if (compromissos[0].status == "pendente") {
          if (compromissoPassado) {
            color = "atrasado";
          } else {
            color = "pendente";
          }
        }
      }
      return color;
    },
    medicamento(item, compromisso) {
      this.infoMedicamento = {
        internacao: item.internacao,
        compromisso: compromisso,
      };
      this.dialogMedicamento = true;
    },
    mapaAnimal(item) {
      this.infoMapaAnimal = item;
      // this.infoMapaAnimal = {
      //   ...item,
      //   idInternacao: item.idInternacao,
      // };
      this.dialogMapaAnimal = true;
    },
  },
};
// Objeto de retorno
// {"data":[{"internacao":{"id":"1","id_entrada":"37","data_entrada":"2024-08-02","hora_entrada":"10:45:41","alimentacao":"ração","score_corporal":"2","curativo":"não","id_consciencia":"1","consciencia":"consciente ","peso":"0.00","temperatura":"0.00","pressao_arterial":"0","glicemia":null,"evolucao":null,"metas":"manter hidratado","id_status_internacao":"1","status_internacao":"internado","id_pet":"120","id_orgao":"2","nome_fantasia":"Ibama","razao_social":"insituto ibama","id_unidade":"1","animal_nome":"Passaro 2","rgv":"58869","id_classe":"1","classe":"Aves","nome_cientifico":"Cyanoloxia brissonii","nome_popular":"AZULÃO","familia":"Cardinalidae"},"agenda":[{"id_internacao":"1","id_prescricao":"15","data_agenda":"2024-08-28","hora_agenda":"01:00:00","id_medicamento":"39","medicamento":"Acalmin","id_tipo_prescricao":"1","descricao_tipo":"Medicamentosa","dosagem":"121","adm_medicamento":"1"},{"id_internacao":"1","id_prescricao":"16","data_agenda":"2024-08-28","hora_agenda":"06:00:00","id_medicamento":"39","medicamento":"Acalmin","id_tipo_prescricao":"1","descricao_tipo":"Medicamentosa","dosagem":"111","adm_medicamento":"1"},{"id_internacao":"1","id_prescricao":"16","data_agenda":"2024-08-28","hora_agenda":"22:00:00","id_medicamento":"39","medicamento":"Acalmin","id_tipo_prescricao":"1","descricao_tipo":"Medicamentosa","dosagem":"111","adm_medicamento":"1"},{"id_internacao":"1","id_prescricao":"15","data_agenda":"2024-08-28","hora_agenda":"09:00:00","id_medicamento":"39","medicamento":"Acalmin","id_tipo_prescricao":"1","descricao_tipo":"Medicamentosa","dosagem":"121","adm_medicamento":"1"},{"id_internacao":"1","id_prescricao":"16","data_agenda":"2024-08-28","hora_agenda":"10:00:00","id_medicamento":"39","medicamento":"Acalmin","id_tipo_prescricao":"1","descricao_tipo":"Medicamentosa","dosagem":"111","adm_medicamento":"1"},{"id_internacao":"1","id_prescricao":"15","data_agenda":"2024-08-28","hora_agenda":"17:00:00","id_medicamento":"39","medicamento":"Acalmin","id_tipo_prescricao":"1","descricao_tipo":"Medicamentosa","dosagem":"121","adm_medicamento":"1"},{"id_internacao":"1","id_prescricao":"16","data_agenda":"2024-08-28","hora_agenda":"14:00:00","id_medicamento":"39","medicamento":"Acalmin","id_tipo_prescricao":"1","descricao_tipo":"Medicamentosa","dosagem":"111","adm_medicamento":"1"},{"id_internacao":"1","id_prescricao":"16","data_agenda":"2024-08-28","hora_agenda":"02:00:00","id_medicamento":"39","medicamento":"Acalmin","id_tipo_prescricao":"1","descricao_tipo":"Medicamentosa","dosagem":"111","adm_medicamento":"1"},{"id_internacao":"1","id_prescricao":"16","data_agenda":"2024-08-28","hora_agenda":"18:00:00","id_medicamento":"39","medicamento":"Acalmin","id_tipo_prescricao":"1","descricao_tipo":"Medicamentosa","dosagem":"111","adm_medicamento":"1"}]},{"internacao":{"id":"4","id_entrada":"41","data_entrada":"2024-08-02","hora_entrada":"14:38:00","alimentacao":"Ração","score_corporal":"5","curativo":"true","id_consciencia":"1","consciencia":"consciente ","peso":"10.50","temperatura":"37.00","pressao_arterial":null,"glicemia":"120","evolucao":"Cura","metas":"Cura","id_status_internacao":"1","status_internacao":"internado","id_pet":"125","id_orgao":"2","nome_fantasia":"Ibama","razao_social":"insituto ibama","id_unidade":"1","animal_nome":"Passaro 782","rgv":"77117877","id_classe":"1","classe":"Aves","nome_cientifico":"Cyanoloxia brissonii","nome_popular":"AZULÃO","familia":"Cardinalidae"},"agenda":[{"id_internacao":"4","id_prescricao":"18","data_agenda":"2024-08-28","hora_agenda":"01:00:00","id_medicamento":"36","medicamento":"Amicacina","id_tipo_prescricao":"1","descricao_tipo":"Medicamentosa","dosagem":"10ml","adm_medicamento":"2"},{"id_internacao":"4","id_prescricao":"18","data_agenda":"2024-08-28","hora_agenda":"13:00:00","id_medicamento":"36","medicamento":"Amicacina","id_tipo_prescricao":"1","descricao_tipo":"Medicamentosa","dosagem":"10ml","adm_medicamento":"2"}]},{"internacao":{"id":"5","id_entrada":"34","data_entrada":"2024-07-25","hora_entrada":"14:41:03","alimentacao":"Ração","score_corporal":"2","curativo":"true","id_consciencia":"1","consciencia":"consciente ","peso":"12.50","temperatura":"35.00","pressao_arterial":null,"glicemia":"100","evolucao":"Cura","metas":"Cura","id_status_internacao":"1","status_internacao":"internado","id_pet":"117","id_orgao":"4","nome_fantasia":"PET CENTRO DE TRATAMENTO ANIMAL LTDA","razao_social":"PET CENTRO DE TRATAMENTO ANIMAL LTDA","id_unidade":"1","animal_nome":"Animal 741852","rgv":"741852","id_classe":"1","classe":"Aves","nome_cientifico":"Anser sp.","nome_popular":"GANSO","familia":"Anatidae"},"agenda":[{"id_internacao":"5","id_prescricao":"20","data_agenda":"2024-08-28","hora_agenda":"03:00:00","id_medicamento":"23","medicamento":"Cicaplast","id_tipo_prescricao":"5","descricao_tipo":"Exames Diagnósticos","dosagem":"4","adm_medicamento":"2"},{"id_internacao":"5","id_prescricao":"20","data_agenda":"2024-08-28","hora_agenda":"19:00:00","id_medicamento":"23","medicamento":"Cicaplast","id_tipo_prescricao":"5","descricao_tipo":"Exames Diagnósticos","dosagem":"4","adm_medicamento":"2"},{"id_internacao":"5","id_prescricao":"20","data_agenda":"2024-08-28","hora_agenda":"07:00:00","id_medicamento":"23","medicamento":"Cicaplast","id_tipo_prescricao":"5","descricao_tipo":"Exames Diagnósticos","dosagem":"4","adm_medicamento":"2"},{"id_internacao":"5","id_prescricao":"20","data_agenda":"2024-08-28","hora_agenda":"23:00:00","id_medicamento":"23","medicamento":"Cicaplast","id_tipo_prescricao":"5","descricao_tipo":"Exames Diagnósticos","dosagem":"4","adm_medicamento":"2"},{"id_internacao":"5","id_prescricao":"20","data_agenda":"2024-08-28","hora_agenda":"11:00:00","id_medicamento":"23","medicamento":"Cicaplast","id_tipo_prescricao":"5","descricao_tipo":"Exames Diagnósticos","dosagem":"4","adm_medicamento":"2"},{"id_internacao":"5","id_prescricao":"20","data_agenda":"2024-08-28","hora_agenda":"15:00:00","id_medicamento":"23","medicamento":"Cicaplast","id_tipo_prescricao":"5","descricao_tipo":"Exames Diagnósticos","dosagem":"4","adm_medicamento":"2"},{"id_internacao":"5","id_prescricao":"21","data_agenda":"2024-08-28","hora_agenda":"12:00:00","id_medicamento":"31","medicamento":"Rifocina Spray ","id_tipo_prescricao":"3","descricao_tipo":"Nutricional","dosagem":"5ml","adm_medicamento":"1"}]}],"message":"Pesquisa realizada com sucesso."}
</script>
<style scoped>
.mapa {
  overflow: auto;
}
.agenda-item {
  display: flex;
}
.info-horarios {
  display: flex;
}
.info-animal {
  border: 1px solid rgba(0, 0, 0, 0.5);
  min-width: 80px;
  text-align: left;
  padding: 5px;
  padding-left: 10px;
  flex: 1;
  display: flex;
}
.details-style {
  padding-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.nome-animal {
  font-size: 1rem;
  font-weight: bold;
  color: #3f3f3f;
  align-content: end;
  display: flex;
}
.desc-animal {
  font-size: 0.75rem;
  font-weight: bold;
  color: #8a8a8a;
  text-transform: lowercase;
}
.horario {
  min-width: 34px;
  max-width: 34px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.horaItem {
  /* padding: 3px 8px;
  border-radius: 20px;
  font-size: smaller; */
  font-weight: bold;
}
.atrasado {
  background-color: rgb(176, 0, 0);
  color: white;
}
.atrasado:hover {
  background-color: rgb(204, 2, 2);
}
.pendente {
  background-color: #2c46cf;
  /* background-color: rgb(244, 115, 0); */
  color: white;
}
.pendente:hover {
  background-color: #546bdf;
  /* background-color: rgb(248, 134, 35); */
}
.aplicado {
  background-color: rgb(22, 185, 0);
  color: white;
}
.aplicado:hover {
  background-color: rgb(36, 204, 14);
}
.style-header {
  background-color: #1daf80;
  border-color: white;
}
.style-header-time {
  background-color: #1daf80;
  border-top-color: white;
  border-bottom-color: white;
  border-right-color: white;
  border-left-color: white;
}
.style-header-time h6 {
  color: white;
  font-weight: bold;
}
</style>
